import { BlogSection } from '@/types/blog';

export const introSection: BlogSection = {
  id: 'intro',
  title: 'Coaching – mehr als nur eine Methode',
  content: `
    <p>
      Coaching ist weit mehr als eine Methode – es ist eine <strong>Haltung</strong>, eine <strong>Denkweise</strong> und eine 
      <strong>Begleitung</strong> auf dem Weg zu persönlicher und beruflicher Weiterentwicklung. Diese Perspektive 
      prägt meine tägliche Arbeit als Coach und zeigt, welche transformative Kraft in diesem Prozess steckt.
    </p>
    
    <p>
      Als Coach sehe ich mich nicht als Experte, der Lösungen vorgibt, sondern als Begleiter, der Menschen dabei 
      unterstützt, ihre eigenen Antworten zu finden. Diese Haltung der Neugier und des Vertrauens in die 
      Ressourcen des Gegenübers ist fundamental für jeden Coaching-Prozess.
    </p>
  `
};